// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._Asb1mwLOc0bpdHWBGBK{box-sizing:border-box;box-shadow:inset 0 0 0 1px var(--border-neutral-default);background:var(--background-primary-inverted-primary);border-radius:6px;align-items:center;gap:4px;padding:4px 8px;display:inline-flex}._Asb1mwLOc0bpdHWBGBK.OaGPrKJPFJUBP9ehMNPX{overflow:auto}._Asb1mwLOc0bpdHWBGBK .ohLTtv0bRdk9DLsgXU4r{width:16px;height:16px}._Asb1mwLOc0bpdHWBGBK .DCmp7ePKMkQmcF6Cwll0{margin-right:4px}._Asb1mwLOc0bpdHWBGBK.tkRGeZtaGKMMkxOWmZkb{background:0 0;border:none;padding:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `_Asb1mwLOc0bpdHWBGBK`,
	"labelEllipsis": `OaGPrKJPFJUBP9ehMNPX`,
	"icon": `ohLTtv0bRdk9DLsgXU4r`,
	"dropdownAvatar": `DCmp7ePKMkQmcF6Cwll0`,
	"chipWithoutBorder": `tkRGeZtaGKMMkxOWmZkb`
};
export default ___CSS_LOADER_EXPORT___;
